import apiClient from "../../../helpers/apiClient";

const INSURANCE_END_ENDPOINTS = {
    teqMobility: "/api/insurance/end-teqMobility-coverage",
    bonzah: "/api/insurance/end-bonzah-coverage",
    abi: "/api/insurance/complete-abi-coverage",
};

/**
 * Maps reservation insuranceType (any casing) to endpoint keys.
 */
export function normalizeInsuranceProvider(insuranceType) {
    if (!insuranceType) return null;

    const key = String(insuranceType).toLowerCase();
    if (key === "teqmobility") return "teqMobility";
    if (key === "bonzah") return "bonzah";
    if (key === "abi") return "abi";

    return null;
}

/**
 * Ends coverage for the reservation's insuranceType only (matches booking check-out).
 * Failures are swallowed so check-out can continue when coverage is already inactive.
 */
export default async function endInsuranceCoverageSilently(reservation) {
    const reservationId = reservation?.id;
    const provider = normalizeInsuranceProvider(reservation?.insuranceType);

    if (!provider || !reservationId) return;

    const endpoint = INSURANCE_END_ENDPOINTS[provider];
    if (!endpoint) return;

    try {
        await apiClient.post(endpoint, { reservationId });
    } catch {
        // Swallow errors so checkout can continue when coverage is already inactive.
    }
}
